import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import About from './pages/About';
import Audience from './pages/Audience';
import Learn from './pages/Learn';
import Buy from './pages/Buy';
import Author from './pages/Author';
import Article from './pages/Article';

// Scroll to top on route change
function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return null;
}

function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="about" element={<About />} />
          <Route path="audience" element={<Audience />} />
          <Route path="learn" element={<Learn />} />
          <Route path="buy" element={<Buy />} />
          <Route path="author" element={<Author />} />
          
          {/* SEO Landing Pages */}
          <Route path="guides/html-css-for-beginners" element={<Article title="HTML & CSS for Beginners" />} />
          <Route path="guides/wordpress-setup" element={<Article title="WordPress Setup Guide" />} />
          <Route path="guides/website-ownership" element={<Article title="Website Ownership Guide" />} />
          <Route path="guides/accessibility" element={<Article title="Accessibility for Websites" />} />
        </Route>
      </Routes>
    </>
  );
}

export default App;